import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const POSWidget = () => {
  const [scanMode, setScanMode] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  const mockProducts = [
    { id: 1, name: "Protein Shake", price: 8.99, category: "Supplements" },
    { id: 2, name: "Gym Towel", price: 12.99, category: "Accessories" },
    { id: 3, name: "Water Bottle", price: 15.99, category: "Accessories" },
    { id: 4, name: "Energy Bar", price: 3.99, category: "Snacks" }
  ];

  const addToCart = (product) => {
    setCartItems(prev => {
      const existing = prev?.find(item => item?.id === product?.id);
      if (existing) {
        return prev?.map(item =>
          item?.id === product?.id
            ? { ...item, quantity: item?.quantity + 1 }
            : item
        );
      }
      return [...prev, { ...product, quantity: 1 }];
    });
  };

  const removeFromCart = (productId) => {
    setCartItems(prev => prev?.filter(item => item?.id !== productId));
  };

  const getTotalAmount = () => {
    return cartItems?.reduce((sum, item) => sum + (item?.price * item?.quantity), 0)?.toFixed(2);
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Quick POS</h2>
        <button
          onClick={() => setScanMode(!scanMode)}
          className={`p-2 rounded-lg transition-colors ${
            scanMode ? 'bg-primary text-primary-foreground' : 'bg-muted text-foreground'
          }`}
        >
          <Icon name="Scan" size={20} />
        </button>
      </div>
      {scanMode ? (
        <div className="text-center py-12">
          <div className="w-24 h-24 mx-auto mb-4 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Scan" size={48} color="var(--color-primary)" />
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            Scan barcode or enter product code
          </p>
          <Input
            type="text"
            placeholder="Enter barcode..."
            className="max-w-xs mx-auto"
          />
        </div>
      ) : (
        <>
          <div className="grid grid-cols-2 gap-3 mb-6">
            {mockProducts?.map((product) => (
              <button
                key={product?.id}
                onClick={() => addToCart(product)}
                className="p-4 rounded-lg bg-muted/30 hover:bg-muted/50 transition-colors text-left focus-ring"
              >
                <p className="text-sm font-medium text-foreground mb-1">
                  {product?.name}
                </p>
                <p className="text-xs text-muted-foreground mb-2">
                  {product?.category}
                </p>
                <p className="text-lg font-bold text-primary data-text">
                  ${product?.price}
                </p>
              </button>
            ))}
          </div>

          {cartItems?.length > 0 && (
            <div className="border-t border-border pt-4">
              <h3 className="text-sm font-semibold text-foreground mb-3">Cart Items</h3>
              <div className="space-y-2 mb-4 max-h-[200px] overflow-y-auto custom-scrollbar">
                {cartItems?.map((item) => (
                  <div
                    key={item?.id}
                    className="flex items-center justify-between p-3 rounded-lg bg-muted/30"
                  >
                    <div className="flex-1">
                      <p className="text-sm font-medium text-foreground">
                        {item?.name}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        Qty: {item?.quantity} × ${item?.price}
                      </p>
                    </div>
                    <div className="flex items-center gap-3">
                      <p className="text-sm font-bold text-foreground data-text">
                        ${(item?.price * item?.quantity)?.toFixed(2)}
                      </p>
                      <button
                        onClick={() => removeFromCart(item?.id)}
                        className="p-1 rounded hover:bg-error/10 transition-colors"
                      >
                        <Icon name="Trash2" size={16} color="var(--color-error)" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-between p-4 rounded-lg bg-primary/10 mb-4">
                <span className="text-sm font-semibold text-foreground">Total</span>
                <span className="text-xl font-bold text-primary data-text">
                  ${getTotalAmount()}
                </span>
              </div>

              <Button variant="default" fullWidth iconName="CreditCard" iconPosition="left">
                Process Payment
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default POSWidget;